export default __webpack_public_path__ + "static/media/IMG_9971.1f404a72.webp";